import { Gift } from "lucide-react";
import Reveal from "./Reveal";

const GOLD_WAFER_IMG =
    "https://customer-assets-v7afamib.emergentagent.net/job_engulf-seminar-kl/artifacts/b30b2d3039f3e0d2_magnific__buatkan-img1-menjadi-poster-lucky-draw-tambahkan-a__93031.webp";

const LuckyDraw = () => (
    <section
        data-testid="lucky-draw-section"
        className="relative overflow-hidden py-24 md:py-32"
    >
        <div className="pointer-events-none absolute left-1/2 top-1/2 h-[560px] w-[560px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-volt/10 blur-3xl" />
        <div className="relative mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8">
            <Reveal>
                <div className="relative">
                    <div className="absolute -inset-3 rounded-[2rem] border border-white/10" />
                    <img
                        src={GOLD_WAFER_IMG}
                        alt="Gold Wafer HABIB — hadiah cabutan bertuah Engulf Summit 2026"
                        loading="lazy"
                        data-testid="lucky-draw-image"
                        className="relative aspect-[16/9] w-full rounded-3xl border border-white/15 object-cover shadow-[0_40px_90px_-30px_rgba(0,0,0,0.9)]"
                    />
                </div>
            </Reveal>

            <div>
                <Reveal>
                    <span className="inline-flex items-center gap-2 rounded-full border border-blood/50 bg-blood/10 px-4 py-1.5">
                        <Gift size={14} className="text-flame" />
                        <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-flame">
                            Cabutan bertuah
                        </span>
                    </span>
                    <h2 className="mt-6 font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-5xl">
                        🎁 SPECIAL{" "}
                        <span className="text-chrome-grad">GIVEAWAY!</span>
                    </h2>
                    <p className="mt-5 font-display text-lg font-bold text-flame md:text-2xl">
                        5 LUCKY WINNERS WILL RECEIVE GOLD WAFERS FROM HABIB!
                    </p>
                    <p className="mt-5 max-w-xl leading-relaxed text-white/70">
                        Bukan sekadar datang untuk belajar, peserta juga
                        berpeluang menyertai cabutan bertuah untuk memenangi
                        Gold Wafer daripada HABIB!
                    </p>
                    <div className="mt-8 inline-flex items-center gap-6 rounded-2xl border border-white/10 bg-white/[0.03] px-6 py-4">
                        <span className="text-outline-chrome font-display text-4xl font-extrabold md:text-5xl">
                            05
                        </span>
                        <span className="font-mono text-[10px] uppercase leading-relaxed tracking-[0.22em] text-white/60">
                            Pemenang bertuah
                            <br />
                            Dipilih di venue
                        </span>
                    </div>
                    <p className="mt-8 text-xs italic text-white/40">
                        *Lucky draw is subject to organizer's terms and
                        eligibility requirements.*
                    </p>
                </Reveal>
            </div>
        </div>
    </section>
);

export default LuckyDraw;
